import { render, staticRenderFns } from "./StudioGuides.vue?vue&type=template&id=64c52515&"
import script from "./StudioGuides.vue?vue&type=script&lang=js&"
export * from "./StudioGuides.vue?vue&type=script&lang=js&"
import style0 from "./StudioGuides.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports